/* eslint-disable no-useless-escape */
import axios from "axios";
import SweetAlert2 from "sweetalert2";
import { Enums } from "./enums";
import { Links } from "./links";
import { appData, C, Text, J, Rnd } from "./global";
import { UserService } from "@/services/api/user";
// SupportType, MethodType, AjaxPromise, Web, Msg, Popup, Wait, Ajax, Exporter

// Ajax Method
export const SupportType = {
  Text: 1,
  Video: 2,
  Carousel: 3,
};

// Ajax Method
export const MethodType = {
  Get: "get",
  Post: "post",
  Put: "put",
  Delete: "delete",
  Filter: "patch",
};

// Ajax Promise
export const AjaxPromise = function (callback) {
    let ok = function () { },
        err = function () { },
        end = function () { };

    let x = this;
    x.isAlert = true;
    x.errorAlert = true;
    x.then = function (fnc) {
        ok = fnc;
        return x;
    };
    x.catch = function (fnc, errorAlert) {
        x.isAlert = false;
        if (errorAlert == undefined) {
            x.errorAlert = true;
        }
        else {
            x.errorAlert = C.Bool(errorAlert);
        }
        err = fnc;
        return x;
    };
    x.finally = function (fnc) {
        end = fnc;
        return x;
    };
    setTimeout(async () => {
        await callback(ok, err, end, x.isAlert, x.errorAlert);
    }, 1);
    return x;
};

export class Web {
    constructor() { }
    static IsMobileTablet() {
        let check = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
            check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }
    static ConnectDetect(isMessage) {
        if (!navigator.onLine) {
            if (C.Bool(isMessage, true)) {
                Msg.Warning("İnternet bağlantısı yok!");
            }
            return false;
        }
        return true;
    }
    static waitMethodList = [];
    static Form(callback, e) {
        let sender;
        if (e) { sender = e.currentTarget ?? e.target; }
        if (!Wait.IsButton(sender)) {
            if (Web.ConnectDetect(true)) {
                if (sender) {
                    Wait.Button(sender, true);
                    Wait.Block(sender.closest('[data-form="true"]'), true);
                    let wait = function () {
                        Wait.Button(sender, false);
                        Wait.Block(sender.closest('[data-form="true"]'), false);
                    };
                    setTimeout(function () {
                        callback(wait);
                    }, 10);
                } else {
                    callback(function () { });
                }
            }
        }
    }
    static Area(callback, sender) {
        if (!Web.ConnectDetect(true)) {
            return;
        }
        if (!sender) {
            callback(function () { });
            return;
        }
        Wait.Block(sender, true);

        let completed = false;

        const wait = function () {
            if (completed) {
                return;
            }

            completed = true;
            Wait.Block(sender, false);
        };

        setTimeout(function () {
            callback(wait);
        }, 10);
    }    
    static Modal(callback, e) {
        let sender = e.currentTarget ?? e.target;
        if (!Wait.IsButton(sender)) {
            if (Web.ConnectDetect(true)) {
                Wait.Button(sender, true);
                Wait.Block(sender.closest(".modal-container"), true);

                let wait = function () {
                    Wait.Button(sender, false);
                    Wait.Block(sender.closest(".modal-container"), false);
                };
                setTimeout(function () {
                    callback(wait);
                }, 10);
            }
        }
    }
    static List(callback, dataId) {
        let sender;
        if (C.Str(dataId) == "" && sender == null) {
            sender = document.querySelector(".smart-table,.smart-list"); // Sender verilmedi ise ilk gelen tablo 
        } else {
            let l = document.querySelector('[id="' + dataId + '"]');
            if (l) {
                sender = l.closest(".smart-table,.smart-list");
            }
        }
        if (sender) {
            if (!Wait.IsBlock(sender)) {
                if (Web.ConnectDetect(true)) {
                    Wait.Block(sender, true);
                    setTimeout(function () {
                        callback(function () {
                            Wait.Block(sender, false);
                        });
                    }, 10);
                }
            }
        }
    }
    static Url(link) {
        return Web.GetFullUrl(link);
    }
    static Redirect(link, target) {
        try {
            target = C.Str(target, "_self");
            if (target == "_self") {
                window.location = Web.GetFullUrl(link);
            } else {
                window.open(Web.GetFullUrl(link), target);
            }
            return true;
        } catch (e) { console.warn(e.message); }
        return false;
    }
    static Refresh() {
        window.location.reload();
    }
    static ReadURLImage(file, img) {
        let reader = new FileReader();
        reader.onload = function (e) {
            if (img != null) {
                img.setAttribute("src", e.target.result);
            }
        };
        reader.readAsDataURL(file);
    }
    static GetBase64(file, callback) {
        let reader = new FileReader();
        reader.onload = function (e) {
            callback(true, e.target.result, { name: file.name, size: file.size, type: file.type });
        };
        reader.onerror = function (e) {
            callback(false, e);
        };
        reader.readAsDataURL(file);
    }
    static GetFileBase64(sender, index, callback) {
        if (sender) {
            if (index < sender.files.length) {
                Web.GetBase64(sender.files[index], callback);
            } else {
                callback(false, "Index Error!");
            }
        } else {
            callback(false, "Element Error!");
        }
    }
    static GetFilesBase64(sender, validBack, callback) {
        if (sender) {
            let nextFile = function (index) {
                if (index < sender.files.length) {
                    try {
                        if (validBack(sender.files[index])) {
                            Web.GetBase64(sender.files[index], function (status, result, attr) {
                                callback(status, result, attr);
                                nextFile(++index);
                            });
                        }
                        else { nextFile(++index); }
                    } catch (e) { nextFile(++index); }
                }
            };
            nextFile(0);
        }
        else { console.error("Element Error!"); }
    }
    static GetUrl(url) {
        url = C.Str(url).replace(/İ/g, 'i').toLowerCase();
        let chars = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "r", "s", "t", "u", "v", "y", "z", "q", "x", "w", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        let result = "";
        for (let i = 0; i < url.length; i++) {
            let v = url[i];
            if (v != String.fromCharCode(775)) {
                let isIn = false;
                for (let j = 0; j < chars.length; j++) {
                    if (v == chars[j]) {
                        result += v;
                        isIn = true;
                        break;
                    }
                }
                if (!isIn) {
                    switch (v) {
                        case "â": result += "a"; break;
                        case "ç": result += "c"; break;
                        case "ı": result += "i"; break;
                        case "ğ": result += "g"; break;
                        case "ş": result += "s"; break;
                        case "ö": result += "o"; break;
                        case "ü": result += "u"; break;
                        default: result += "-"; break;
                    }
                }
            }
        }
        result = result.replace(/([-]+)/gm, '-').replace(/(^[-]|[-]$)/gm, '');
        if (result.length == 0) { result = '-'; }
        return result;
    }
    static GetMultiLangUrl(url, isLower) {
        url = C.Str(url);
        if (isLower) {
            url = url.replace(/İ/g, 'i').toLowerCase();
        }
        let chars = ' `!@#$%^&*()_+\-=\[\]{};\':"\\|,.<>\/?~' + String.fromCharCode(775);
        let result = "";
        for (let i = 0; i < url.length; i++) {
            let v = url[i];
            let isIn = false;
            for (let j = 0; j < chars.length; j++) {
                if (v == chars[j]) {
                    isIn = true;
                    break;
                }
            }
            if (isIn) { result += "-"; }
            else { result += Text.Tr(v); }
        }
        result = result.replace(/([-]+)/gm, '-').replace(/(^[-]|[-]$)/gm, '');
        if (C.IsNumeric(result)) { result = '-' + result; }
        if (result.length == 0) { result = '-'; }
        return result;
    }
    static Base64Split(v) {
        v = C.Str(v);
        if (v.indexOf("data:") == 0 && v.indexOf(";base64,") > 0) {
            let m = v.match("data:(?<type>.+?);base64,(?<data>.+)");
            if (m != null) {
                return { Type: m.groups.type, Data: m.groups.data };
            }
        }
        return null;
    }
    static Base64Valid(v) {
        if (C.Str(v) != '') {
            let m = Web.Base64Split(v);
            if (m != null) {
                return (m.Type != '' && m.Data != '');
            }
        }
        return false;
    }
    static FileValid(v) {
        if (C.Str(v) != '') {
            return !Web.Base64Valid(v);
        }
        return false;
    }
    static AddQueryParam(url, key, value) {
        const urlParts = url.split('#');
        const baseUrl = urlParts[0];
        const fragment = urlParts[1];

        function getSearch(url) {
            const queryString = url.split('?')[1];
            if (!queryString) {
                return "";
            }
            const queryParams = {};
            queryString.split('&').forEach(param => {
                const [key, value] = param.split('=');
                queryParams[key] = decodeURIComponent(value);
            });
            return queryParams;
        }
        const urlSearchParams = new URLSearchParams(getSearch(baseUrl));
        urlSearchParams.set(key, value);
        return baseUrl.split('?')[0] + "?" + urlSearchParams.toString() + (fragment ? "#" + fragment : "");
    }
    static QueryString(key, def) {
        key = Text.ToLowerEn(key);
        let q = C.Str(window.location.search);
        if (q.indexOf("?") == 0) {
            q = q.substring(1);
        }
        let p = q.split("&");
        for (let i = 0; i < p.length; i++) {
            let kv = p[i].split("=");
            if (Text.ToLowerEn(kv[0]) == key) {
                if (kv.length == 2) {
                    return decodeURIComponent(kv[1]);
                }
                break;
            }
        }
        return def;
    }
    static QueryStringReplace(list) {
        let q = C.Str(window.location.search);
        if (q.indexOf("?") == 0) {
            q = q.substring(1);
        }

        for (let i = 0; i < list.length; i++) {
            let r = { Key: list[i][0], Value: list[i][1] };
            r.Key = Text.ToLowerEn(r.Key);
            let p = q.split("&");
            q = "";
            let isIn = false;
            for (let j = 0; j < p.length; j++) {
                if (q != "") {
                    q += "&";
                }
                if (Text.ToLowerEn(p[j].split("=")[0]) == r.Key) {
                    q += r.Key + "=" + r.Value;
                    isIn = true;
                } else {
                    q += p[j];
                }
            }
            if (!isIn) {
                if (q != "") {
                    q += "&";
                }
                q += r.Key + "=" + r.Value;
            }
        }
        q = (q.length > 0 ? "?" : "") + q;
        return window.location.pathname + q;
    }
    static EnterForm(form, senderId) {
        if (typeof form === "string") {
            form = document.querySelector(form);
        }
        appData.fn.each(
            form.querySelectorAll(
                'input[type="email"], input[type="tel"], input[type="tc"], input[type="text"], input[type="password"]'
            ),
            function () {
                this.addEventListener("keypress", function (event) {
                    if (event.which == 13) {
                        event.preventDefault();
                        document.querySelector("#" + senderId).click();
                    }
                });
            }
        );
    }
    static OutHtmlTag(sender) {
        let c = sender.cloneNode();

        let div = document.createElement("DIV");
        div.appendChild(c);
        return div.innerHTML;
    }
    static ClipboardText(value, allowMsg) {
        let d = document.createElement("DIV");
        d.innerHTML = '<div id="clipboard-copy"><textarea></textarea></div>';
        d.style.opacity = 0;
        d.style.position = "fixed";
        d.style.left = "-100%";

        let div = d.firstElementChild;
        document.querySelector("body").appendChild(div);
        let input = document.querySelector("#clipboard-copy textarea");
        input.value = value;
        input.select();
        document.execCommand("copy");
        document.querySelector("#clipboard-copy").remove();
        if (allowMsg == null) {
            allowMsg = true;
        }
        if (C.Bool(allowMsg)) {
            Msg.Info("Kopyalandı!");
        }
    }
    static ClipboardStyleText(element, allowMsg) {
        let doc = document,
            range,
            selection;

        if (doc.body.createTextRange) {
            range = doc.body.createTextRange();
            range.moveToElementText(element);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = doc.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        if (allowMsg == null) {
            allowMsg = true;
        }
        if (C.Bool(allowMsg)) {
            Msg.Info("Kopyalandı!");
        }
    }
    static SoundPlay(name) {
        let d = document.createElement("DIV");
        d.innerHTML = '<div id="sound" style="display:none;"></div>';
        let div = d.firstElementChild;
        if (document.querySelectorAll("#sound").length == 0) {
            document.querySelector("body").appendChild(div);
        }

        document.querySelector("#sound").innerHTML =
            "<audio autoplay>" +
            '   <source src="/assets/sound/' +
            name +
            '.mp3" type="audio/mpeg" />' +
            '   <source src="/assets/sound/' +
            name +
            '.ogg" type="audio/ogg" />' +
            //'   <embed src="/assets/sound/' + name + '.mp3" hidden="true" autostart="true" loop="false"  />' +
            "</audio>";
    }
    static YoutubeUrlToEmbed(url) {
        url = C.Str(url);
        if (url.toLowerCase().indexOf("youtube.com/embed/") > -1) {
            return url;
        }
        let query = url.split("?");
        if (query.length == 2) {
            let p = query[1].split("&");
            let start = "";
            url = "";
            for (let i = 0; i < p.length; i++) {
                let kv = p[i].split("=");
                if (kv.length == 2) {
                    if (kv[0] == "t") {
                        start = "&start=" + kv[1];
                    }
                    if (kv[0] == "v") {
                        url = "https://www.youtube.com/embed/" + kv[1];
                    }
                }
            }
            if (url != "") {
                return url + start;
            }
        }
        return "";
    }
    static WebPConvert(base64, quality, callback) {
        try {
            if (quality == null) {
                quality = 1.0;
            }
            let img = new Image();
            img.onload = function () {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                let webP = canvas.toDataURL("image/webp", quality);
                callback(true, webP);
            };
            img.src = base64;
        } catch (e) {
            callback(false, "");
        }
    }
    static GetFileName(path) {
        let p = C.Str(path).split("/");
        let file = p[p.length - 1];
        return file.substring(0, file.lastIndexOf("."));
    }
    static GetExtension(path) {
        let p = C.Str(path).split("/");
        let file = p[p.length - 1];
        return file
            .substring(file.lastIndexOf("."))
            .toLowerCase()
            .replace(/ı/g, "i");
    }
    static GetMimeType(v) {
        v = C.Str(v);
        if (v.indexOf("data:") == 0 && v.indexOf(";base64,") > 0) {
            let m = v.match("data:(?<type>.+?);base64");
            if (m != null) {
                return m.groups.type;
            }
        }
        return null;
    }
    static CovertGroup(mimeType) {
        mimeType = C.Str(mimeType).toLowerCase().replace(/ı/g, "i");
        for (let i = 0; i < Enums.FILE_TYPE.length; i++) {
            let r = Enums.FILE_TYPE[i];
            if (r.MimeType.some(r2 => r2 == mimeType)) {
                return r.Group;
            }
        }
        return null;
    }
    static CovertExtension(mimeType) {
        mimeType = C.Str(mimeType).toLowerCase().replace(/ı/g, "i");
        for (let i = 0; i < Enums.FILE_TYPE.length; i++) {
            let r = Enums.FILE_TYPE[i];
            if (r.MimeType.some(r2 => r2 == mimeType)) {
                return r.Extension;
            }
        }
        return null;
    }
    static GetFileNameExtension(path) {
        let p = C.Str(path).split("/");
        let file = p[p.length - 1];
        return {
            Name: file.substring(0, file.lastIndexOf(".")),
            Extension: file.substring(file.lastIndexOf(".")),
        };
    }
    static Base64Blob(base64, sliceSize) {
        let b = Web.Base64Split(base64);
        sliceSize = C.Int0(sliceSize, 512);
        let byteCharacters = atob(b.Data);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, { type: b.Type });
        return blob;
    }
    static BlobBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                resolve(base64String);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    static GetFullUrl(link) {
        // Site urlsini çeker
        let url = C.Str(link);
        if (
            url.indexOf("#") == 0 ||
            url.toLowerCase().indexOf("tel:") == 0 ||
            url.toLowerCase().indexOf("sms:") == 0 ||
            url.toLowerCase().indexOf("mailto:") == 0 ||
            url.toLowerCase().indexOf("geo:") == 0 ||
            url.toLowerCase().indexOf("market:") == 0
        ) {
            return url;
        }
        if (url.split("#")[0].split("?")[0].indexOf("://") > -1) {
            return url;
        }
        if (Web.Base64Valid(url)) {
            return url;
        }
        if (url.length >= 2) {
            if (C.Str(url[0]) + C.Str(url[1]) == "~/") {
                url = url.substring(2);
            } else if (C.Str(url[0]) == "/") {
                url = url.substring(1);
            }
        } else if (url == "/") {
            url = "";
        }
        return appData.base + url;
    }
    static Media(link, def, isVersion) {
        isVersion = C.Bool(isVersion);
        let url = C.Str(link);
        if (url == "") {
            return C.Str(def) != "" ? Web.Server(def) : "";
        }
        if (url == "#") {
            return "#";
        }
        if (url.split("#")[0].split("?")[0].indexOf("://") > -1) {
            return url;
        }
        if (Web.Base64Valid(url)) {
            return url;
        }
        let getVersion = function (l) {
            if (isVersion) {
                l = Web.AddQueryParam(l, "v", Rnd.Text(5, false));
            }
            return l;
        };
        return appData.mediaBase + getVersion(url);
    }
    static Server(link, def, isVersion) {
        let url = C.Str(link);
        if (url == "") {
            url = C.Str(def);
            isVersion = false;
            if (url == "") {
                return url;
            }
        }
        let version = C.Bool(isVersion) ? "?v=" + Rnd.Text(5, false) : ''
        if (
            url.indexOf("#") == 0 ||
            url.toLowerCase().indexOf("tel:") == 0 ||
            url.toLowerCase().indexOf("sms:") == 0 ||
            url.toLowerCase().indexOf("mailto:") == 0 ||
            url.toLowerCase().indexOf("geo:") == 0 ||
            url.toLowerCase().indexOf("market:") == 0
        ) {
            return url;
        }
        if (url.split("#")[0].split("?")[0].indexOf("://") > -1) {
            return url + version;
        }
        if (Web.Base64Valid(url)) {
            return url;
        }
        if (url.length >= 2) {
            if (C.Str(url[0]) + C.Str(url[1]) == "~/") {
                url = url.substring(2);
            } else if (C.Str(url[0]) == "/") {
                url = url.substring(1);
            }
        } else if (url == "/") {
            url = "";
        }
        return appData.serverBase + url + version;
    }
    static PreviewExtension(extension, path) {
        switch (extension) {
            case '.jpg':
            case '.png':
            case '.webp':
            case '.avif':
            case '.gif':
            case '.svg':
                //return Web.Url('/assets/img/format/img.png');
                return Web.Server(path, Web.Url(appData.default.img));
            case '.mp4':
            case '.mpeg':
            case '.avi':
            case '.flv':
            case '.webm':
                return Web.Url('/assets/img/format/doc.png');
            case '.mp3':
            case '.wav':
            case '.wma':
                return Web.Url('/assets/img/format/doc.png');
            case '.doc':
            case '.docx':
                return Web.Url('/assets/img/format/word.png');
            case '.xls':
            case '.xlsx':
                return Web.Url('/assets/img/format/excel.png');
            case '.pdf':
                return Web.Url('/assets/img/format/pdf.png');
            case '.csv':
                return Web.Url('/assets/img/format/csv.png');
            case '.txt':
                return Web.Url('/assets/img/format/txt.png');
            case '.xml':
                return Web.Url('/assets/img/format/xml.png');
            default:
                return Web.Url('/assets/img/format/doc.png');
        }
    }
    static PreviewMimeType(base64) {
        let p = Web.Base64Split(base64);
        let mimeType = '';
        if (p) { mimeType = p.Type; }
        switch (mimeType) {
            case "image/jpeg":
            case "image/jpg":
            case "image/png":
            case "image/webp":
            case "image/avif":
            case "image/gif":
            case "image/svg+xml":
                //return Web.Url('/assets/img/format/img.png');
                return Web.Server(base64, this.defaultImage, true);
            case "video/mp4":
            case "application/mp4":
            case "video/x-msvideo":
            case "video/x-flv":
            case "video/webm":
                return Web.Url('/assets/img/format/doc.png');
            case "audio/mpeg3":
            case "audio/x-mpeg-3":
            case "audio/mp3":
            case "audio/x-wav":
            case "audio/x-ms-wma":
                return Web.Url('/assets/img/format/doc.png');
            case "application/msword":
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                return Web.Url('/assets/img/format/word.png');
            case "application/vnd.ms-excel":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                return Web.Url('/assets/img/format/excel.png');
            case "application/pdf":
                return Web.Url('/assets/img/format/pdf.png');
            case "text/csv":
                return Web.Url('/assets/img/format/csv.png');
            case "text/plain":
                return Web.Url('/assets/img/format/txt.png');
            case "application/xml":
                return Web.Url('/assets/img/format/xml.png');
            default:
                return Web.Url('/assets/img/format/doc.png');
        }
    }
    static GetBase64Extension(v) {
        const p = Web.GetMimeType(v);
        if (p) {
            return Web.CovertExtension(p);
        }
        return null;
    }
}

// Mesaj Verme
export class Msg {
  constructor() {}
  static Success(message, title, callback) {
    Popup.Success(message, title, null, null, callback);
  }
  static Info(message, title, callback) {
    Popup.Info(message, title, null, null, callback);
  }
  static Warning(message, title, callback) {
    Popup.Warning(message, title, null, null, callback);
  }
  static Error(message, title, callback) {
    Popup.Danger(message, title, null, null, callback);
  }
  static Danger(message, title, callback) {
    Popup.Danger(message, title, null, null, callback);
  }
}

export class Popup {
    constructor() { }
    static Html(message, title, btnList, callback) {
        var btnList = btnList.split(',');

        SweetAlert2.fire({
            title: title,
            html: message,
            showConfirmButton: btnList.length > 0 && btnList[0] != "",
            showCancelButton: btnList.length > 1 && btnList[1] != "",
            showDenyButton: btnList.length > 2 && btnList[2] != "",
            confirmButtonText: btnList.length > 0 ? btnList[0] : "",
            cancelButtonText: btnList.length > 1 ?btnList[1]: "",
            denyButtonText: btnList.length > 2 ? btnList[2]: "",
             
            customClass: {
                confirmButton: "btn btn-primary me-3",
                cancelButton: "btn btn-danger me-3",
                denyButton: "btn btn-info me-3",
            },
            buttonsStyling: false,
        }).then(function (e) {
            if (callback != null) {
                callback(e);
            }
        });
    }
    static Success(message, title, btnText, timer, callback) {
        btnText = C.Str(btnText);
        timer = C.Int0(timer, 2000);
        timer += message.length * 100;

        SweetAlert2.fire({
            //position: 'top-end',            
            title: C.Str(title, "İşlem başarılı"),
            html: message,
            //type: 'success',
            icon: "success",
            showConfirmButton: btnText != "",
            timer: timer,
            confirmButtonText: btnText,
        }).then(function (e) {
            if (callback != null) {
                callback(e.dismiss);
            }
        });
    }
    static Info(message, title, btnText, timer, callback) {
        btnText = C.Str(btnText);
        timer = C.Int0(timer, 2000);
        timer += message.length * 100;

        SweetAlert2.fire({
            //position: 'top-end',
            title: C.Str(title, "Bilgilendirme"),
            html: message,
            //type: 'info',
            icon: "info",
            showConfirmButton: btnText != "",
            timer: timer,
            confirmButtonText: btnText,
        }).then(function (e) {
            if (callback != null) {
                callback(e.dismiss);
            }
        });
    }
    static Warning(message, title, btnText, timer, callback) {
        btnText = C.Str(btnText);
        timer = C.Int0(timer, 3000);
        timer += message.length * 100;

        SweetAlert2.fire({
            //position: 'top-end',
            title: C.Str(title, "Uyarı"),
            html: message,
            //type: 'warning',
            icon: "warning",
            showConfirmButton: btnText != "",
            timer: timer,
            confirmButtonText: btnText,
        }).then(function (e) {
            if (callback != null) {
                callback(e.dismiss);
            }
        });
    }
    static Danger(message, title, btnText, timer, callback) {
        btnText = C.Str(btnText, "Tamam");
        timer = C.Int0(timer, 3000);
        //timer += message.length * 100;

        SweetAlert2.fire({
            //position: 'top-end',
            title: C.Str(title, "Hata"),
            html: message,
            //type: 'error',
            icon: "error",
            showConfirmButton: btnText != "",
            //timer: timer,
            confirmButtonText: btnText,
        }).then(function (e) {
            if (callback != null) {
                callback(e.dismiss);
            }
        });
    }
    static Confirm(callback, args) {
        if (args == null) {
            args = {};
        }
        SweetAlert2.fire({
            title: C.Str(args.title, "Emin Misiniz?"),
            html: C.Str(args.content, "Bu işlemi yapmak istediğinize emin misiniz?"),
            //type: 'info',
            icon: "question",
            showCancelButton: true,
            showDenyButton: C.Bool(args.btn3Show),
            //confirmButtonColor: '#3085d6',
            //cancelButtonColor: '#d33',
            confirmButtonText: C.Str(args.btn1, "Onayla"),
            cancelButtonText: C.Str(args.btn2, "Vazgeç"),
            denyButtonText: C.Str(args.btn3, "Tümünü Onayla"),
            customClass: {
                confirmButton: "btn btn-danger me-3",
                cancelButton: "btn btn-primary",
                denyButton: "btn btn-info me-3",
            },
            buttonsStyling: false,
            reverseButtons: false,
        }).then((result) => {
            if (result.isConfirmed) {
                if (Web.ConnectDetect(false)) {
                    callback(() => {
                        Msg.Success(
                            C.Str(args.successContent, "İşleminiz gerçekleştirildi"),
                            C.Str(args.successTitle, "İşlem Başarılı")
                        );
                    });
                }
            }
            else if (result.isDenied) {
                args.callbackDeny(() => {
                    Msg.Success(
                        C.Str(args.successContent, "İşleminiz gerçekleştirildi"),
                        C.Str(args.successTitle, "İşlem Başarılı")
                    );
                });
            }
        });
    }
    static Delete(callbackDelete, args) {
        if (args == null) {
            args = {};
        }
        SweetAlert2.fire({
            title: C.Str(args.title, "Silme Onayı"),
            html: C.Str(args.content, "Seçilen kaydı silmek istediğinize emin misiniz?"),
            //type: 'warning',
            icon: "warning",
            showCancelButton: true,
            showDenyButton: C.Bool(args.btn3Show),
            //confirmButtonColor: '#3085d6',
            //cancelButtonColor: '#d33',
            confirmButtonText: C.Str(args.btn1, "Sil"),
            cancelButtonText: C.Str(args.btn2, "Vazgeç"),
            denyButtonText: C.Str(args.btn3, "Tümünü Sil"),
            customClass: {
                confirmButton: "btn btn-danger me-3",
                cancelButton: "btn btn-primary",
                denyButton: "btn btn-info me-3",
            },
            buttonsStyling: false,
            reverseButtons: false,
        }).then((result) => {
            if (result.isConfirmed) {
                if (Web.ConnectDetect(false)) {
                    callbackDelete(() => {
                        Msg.Success(
                            C.Str(args.successContent, "Silme işleminiz gerçekleştirildi."),
                            C.Str(args.successTitle, "Silindi")
                        );
                    });
                }
            }
            else if (result.isDenied && args.callbackDeny) {
                args.callbackDeny(() => {
                    Msg.Success(
                        C.Str(args.successContent, "Silme işleminiz gerçekleştirildi."),
                        C.Str(args.successTitle, "Silindi")
                    );
                });
            }
        });
    }
    static Support(data) {
        let html = document.createElement("DIV");
        let confirmButton = false;
        let type = data.Type;
        if (type == null) {
            type = SupportType.Text;
        }
        let width = "32em";
        switch (type) {
            case SupportType.Text: // data = { Type: SupportType.Text, Text: 'Bilgi Mesajı' };
                html.innerText = C.Str(data.Text);
                confirmButton = true;
                break;
            case SupportType.Video: // data = { Type: SupportType.Video, Src: '', Text : 'Bilgi Mesajı' }
                width = "60em";
                data.Src = C.Str(data.Src);
                let src = Text.Rep(
                    Text.Rep(data.Src.split("&")[0], "https://", "//"),
                    "http://",
                    "//"
                );
                src = Text.Rep(
                    Text.Rep(
                        Text.Rep(
                            Text.Rep(src, "//www.youtube.com/", "/"),
                            "//m.youtube.com/",
                            "/"
                        ),
                        "//youtu.be/",
                        ""
                    ),
                    "//www.youtube-nocookie.com/",
                    "/"
                );
                src = Text.Rep(
                    Text.Rep(Text.Rep(src, "/watch?v=", ""), "/embed/", ""),
                    "?t=",
                    "?start="
                );

                if (data.Src.split("&").length > 1) {
                    let l = data.Src.split("&");
                    src += (src.indexOf("?") > -1 ? "%" : "?") + l[1];
                    for (let i = 2; i < l.length; i++) {
                        src += "&" + l[i];
                    }
                }
                src = Text.Rep(src, "&t=", "&start=");

                html.appendChild(
                    appData.fn.create(
                        '<iframe width="100%" height="504" src="https://www.youtube.com/embed/' +
                        src +
                        '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
                    )
                );
                let p = document.createElement("P");
                p.innerText = C.Str(data.Text);
                html.appendChild(p);
                break;
            case SupportType.Carousel:
                //data = { Type: SupportType.Video, List : [{ Src: '', Title: '', Text : '' }, { Src: '', Title: '', Text : '' }] };
                html.appendChild(
                    appData.fn.create(
                        `<div id="supportCarousel" class="carousel slide" data-ride="carousel">
				<ol class="carousel-indicators"></ol><div class="carousel-inner"></div>
                <a class="carousel-control-prev" href="#supportCarousel" role="button" data-slide="prev"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Geri</span></a>
                <a class="carousel-control-next" href="#supportCarousel" role="button" data-slide="next"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">İleri</span></a>
                </div>`
                    )
                );
                for (let i = 0; i < data.List.length; i++) {
                    let r = data.List[i];
                    r.title = C.Str(r.title);
                    r.content = C.Str(r.content);
                    html
                        .querySelector(".carousel-indicators")
                        .appendChild(
                            appData.fn.create(
                                '<li data-target="#supportCarousel" data-slide-to="' +
                                i +
                                '" ' +
                                (i == 0 ? 'class="active"' : "") +
                                "></li>"
                            )
                        );
                    let div = appData.fn.create(
                        '<div class="carousel-item ' +
                        (i == 0 ? "active" : "") +
                        '">' +
                        '<img class="d-block" style="width:100%" src="' +
                        Web.GetFullUrl(r.Src) +
                        '" alt="Görsel ' +
                        (i + 1) +
                        '">' +
                        '<div class="carousel-caption d-none d-md-block">' +
                        (r.title.length > 0
                            ? '<h5 class="text-white m-0">' + C.Str(r.title) + "</h5>"
                            : "") +
                        (r.content.length > 0
                            ? '<p class="text-white">' + r.content + "</p>"
                            : "") +
                        "</div></div>"
                    );
                    html.querySelector(".carousel-inner").appendChild(div);
                }
                break;
        }
        SweetAlert2.fire({
            width: width,
            position: "top-center",
            html: html,
            type: confirmButton ? "info" : "",
            icon: confirmButton ? "info" : "",
            showConfirmButton: confirmButton,
            timer: 0,
            confirmButtonText: C.Str("Tamam"),
        }); //.then(function (e) { if (callback != null) { callback(e.dismiss); } });
    }
}

// Button, Div-Block, Page
export class Wait {
    static IsButton(sender) {
        if (!sender) {
            return false;
        }
        return C.Bool(sender.getAttribute("data-wait"));
    }
    static IsBlock(sender) {
        if (!sender) {
            return false;
        }
        if (sender.querySelector(".block-wait")) {
            return true;
        }
        return false;
    }
    static IsPage() {
        if (window.querySelector("body.page-wait")) {
            return true;
        }
        return false;
    }
    static Button(sender, state) {
        if (!sender) {
            return false;
        }
        let css = "wait-btn";
        let isWait = C.Bool(sender.getAttribute("data-wait"));
        if (C.Bool(state)) {
            // Bekle
            if (!isWait) {
                //sender.style.position = 'relative';
                sender.setAttribute("data-wait", true);
                appData.fn.each(sender, function () {
                    this.setAttribute("disabled", "disabled");
                });
                sender.classList.add(css);
                let waiting = appData.fn.create(
                    '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
                );
                sender.insertBefore(waiting, sender.firstChild);
                return true;
            }
        } else {
            if (isWait) {
                sender.removeAttribute("data-wait");
                appData.fn.each(sender, function () {
                    this.removeAttribute("disabled");
                });
                let waiting = sender.querySelector(".spinner-border");
                if (waiting) {
                    waiting.remove();
                }
                sender.classList.remove(css);
                return true;
            }
        }
        return false;
    }    
    static Block(sender, state) {
    if (!sender) {
        return false;
    }

    const css = "wait-block";
    sender.waitCount = sender.waitCount || 0;

    if (C.Bool(state)) {
        if (sender.waitCloseTimer) {
            clearTimeout(sender.waitCloseTimer);
            sender.waitCloseTimer = null;
        }

        sender.waitCount++;

        if (sender.waitCount > 1) {
            return true;
        }

        if (sender.waiting) {
            clearTimeout(sender.waiting);
        }

        sender.waiting = setTimeout(function () {
            sender.waiting = null;

            if (sender.waitCount <= 0) {
                return;
            }

            if (!sender.classList.contains(css)) {
                sender.classList.add(css);
            }

            if (!sender.querySelector(".spinner")) {
                sender.appendChild(appData.fn.create(
                    '<div class="spinner"><img src="/assets/img/logo/logo-colorful.svg" style="width: 20%" class="flashing-logo"/></div>'
                ));
            }
        }, 250);

        return true;
    }

    sender.waitCount = Math.max(0, sender.waitCount - 1);

    if (sender.waitCount > 0) {
        return true;
    }

    if (sender.waitCloseTimer) {
        clearTimeout(sender.waitCloseTimer);
    }

    sender.waitCloseTimer = setTimeout(function () {
        sender.waitCloseTimer = null;

        if (sender.waitCount > 0) {
            return;
        }

        if (sender.waiting) {
            try {
                clearTimeout(sender.waiting);
            } catch (ex) {
                console.warn(ex);
            }

            sender.waiting = null;
        }

        sender.classList.remove(css);

        const spinners = sender.querySelectorAll(".spinner");

        for (let i = 0; i < spinners.length; i++) {
            spinners[i].remove();
        }
    }, 100);

    return true;
}
    static Page(state) {
        let css = "wait-page";
        let body = document.querySelector("body");
        if (C.Bool(state)) {
            // Bekle
            body.classList.add(css);
            let div = appData.fn.create(
                //'<div class="spinner"><div class="spinner-border" role="status"></div></div>'
                '<div class="spinner"><img src="/assets/img/logo/logo-colorful.svg" style="width: 20%" class="flashing-logo"/></div>'
            );
            body.appendChild(div);
        } else {
            body.classList.remove(css);
            let l = body.querySelectorAll(".spinner");
            for (let i = 0; i < l.length; i++) {
                l[i].remove();
            }
        }
    }
}

// Ajax İşlemleri
export class Ajax {
    constructor() { }
    static GetJson(url, callback) {
        if (C.Str(url) == "") {
            console.error("Ajax:Url boş olamaz!");
            return;
        }
        axios
            .get(Web.Server(url))
            .then(function (response) {
                callback(true, response.data);
            })
            .catch(function (error) {
                callback(false, error);
            });
        //.finally(function() { this.loading = false })
    }
    static Api(method, url, data, wait, version, escapeToken) {
        if (C.Str(url) == "") {
            Msg.Error("Ajax:Url boş olamaz!");
            return;
        }
        let isLocal = false;
        version = C.Str(version);
        escapeToken = C.Bool(escapeToken);
        if (url.indexOf("//") == -1) { isLocal = true; }
        
        if (!data) { data = {}; }
        return new AjaxPromise(async function (ok, err, end, isAlert, errorAlert) {
            try {
                const accessToken = await UserService.GetAccessRefreshToken(escapeToken);
                const headers = {
                    "Content-Type": "application/json;charset=utf-8",
                    "Authorization": isLocal && !Text.IsEmpty(accessToken) ? ("Bearer " + C.Str(accessToken)) : "",
                };
                axios({
                    url: Web.Server("/api/portal/" + (version != "" ? "/" + version : "") + url),
                    method: method,
                    headers: headers,
                    data: data,
                })
                .then(function (response) {
                    let r = response.data;
                    r.status = C.Int(r.status); // 2: Başarılı
                    r.message = C.Str(r.message); // Mesaj
                    if (r.status == 1) {
                        ok(r.data, r.message);
                    }
                    else {
                        if (isAlert) {
                            switch (r.Status) {
                                case 2:
                                    Msg.Info(r.message);
                                    break;
                                case 3:
                                    Msg.Warning(r.message);
                                    break;
                                case 4:
                                default:
                                    Msg.Error(r.message);
                                    break;
                            }
                        }
                        err(r);
                    }
                    if (wait) { wait(); }
                    if (end) { end(r.status); }
                })
                .catch(function (error) {
                    if (error && !axios.isAxiosError(error)) {
                        if (wait) { wait(); }
                        if (error.response) {
                            switch (error.response.status) {
                                case Enums.HTTPSTATUS.Unauthorized:
                                    {
                                        //console.warn("Unauthorized");
                                        if (err) { err(error); }
                                        //else if (errorAlert) { Msg.Warning("Unauthorized"); }
                                        if (Text.IsEmpty(accessToken)) { // Sadece login değil ise izin ver
                                            UserService.Logout(); // Login Başarısız;
                                        }
                                    }
                                    break;
                                case Enums.HTTPSTATUS.Forbidden:
                                    //TODO: 500 sayfasına yönlendir
                                    if (err) { err(error); }
                                    else if (errorAlert) { Msg.Warning("Yetkiniz yetersiz!"); }
                                    break;
                                case Enums.HTTPSTATUS.BadRequest:
                                    {
                                        let msg = "";
                                        for (const [key, value] of Object.entries(error.response.data.errors)) {
                                            for (let i = 0; i < value.length; i++) {
                                                if (msg.length > 0) { msg += "<br>"; }
                                                msg += value[i];
                                            }
                                        }
                                        if (errorAlert) { Msg.Warning(msg); }
                                    }
                                    break;
                                case Enums.HTTPSTATUS.NotFound:
                                    //TODO: 404 sayfasına yönlendir
                                    if (err) { err(error); }
                                    else if (errorAlert) { Msg.Warning("Sayfa bulunamadı!"); }
                                    break;
                                case Enums.HTTPSTATUS.RequestTimeout:
                                    //TODO: 500 sayfasına yönlendir
                                    if (err) { err(error); }
                                    else if (errorAlert) { Msg.Warning("İstek zaman aşımına uğradı!"); }
                                    break;
                                case Enums.HTTPSTATUS.TooManyRequests:
                                    //TODO: 500 sayfasına yönlendir
                                    if (err) { err(error); }
                                    else if (errorAlert) { Msg.Warning("Çok fazla istekte bulunuldu!"); }
                                    break;
                            }
                        }
                        if (end) { end(3); /* Warning */ }
                    }
                    else {
                        if (wait) { wait(); }
                        if (err) { err(error); }
                        else {
                            console.error(error);
                            if (errorAlert) { Msg.Error("Beklenmeyen bir hata oluştu!"); }
                        }
                        if (end) { end(4); /* Error */ }
                    }
                });
            }
            catch (ex) {
                if (wait) { wait(); }
                if (err) { err(ex); }
                else {
                    console.error(ex);
                    if (errorAlert) { Msg.Error("Beklenmeyen bir hata oluştu!"); }
                }
                if (end) { end(4); /* Error */ }
            }
        });
    }
}

export class Exporter {
    constructor() { }

    static ExcludeImg(p) {
        // Removes all img tags
        const _patt = /(\s+alt\s*=\s*"([^"]*)"|\s+alt\s*=\s*'([^']*)')/i;
        return p.replace(/<img[^>]*>/gi, function fnc(x) {
            let res = _patt.exec(x);
            if (res !== null && res.length >= 2) {
                return res[2];
            } else {
                return "";
            }
        });
    }
    static ExcludeInputs(p) {
        // Removes input params
        const _patt = /(\s+value\s*=\s*"([^"]*)"|\s+value\s*=\s*'([^']*)')/i;
        return p.replace(/<input[^>]*>|<\/input>/gi, function fnc(x) {
            let res = _patt.exec(x);
            if (res !== null && res.length >= 2) {
                return res[2];
            } else {
                return "";
            }
        });
    }
    static ExcludeLinks(p) {
        // Removes all link tags
        return p.replace(/<a[^>]*>|<\/a>/gi, "");
    }

    static ToExcel(tableList, settings) {
        if (settings == null) {
            settings = {};
        }
        settings.FileName = C.Str(settings.FileName, "Excel File") + ".xls";
        settings.WorkSheetName = C.Str(settings.WorkSheetName, "Worksheet");
        settings.SheetName = C.Str(settings.SheetName, "Sheet");

        settings.AllowLink = C.Bool(settings.AllowLink);
        settings.AllowImg = C.Bool(settings.AllowImg);
        settings.AllowInput = C.Bool(settings.AllowInput);

        const getTd = function (parent, callback, hiddenColumns) {
            let html = "";
            if (parent) {
                let trList = parent.querySelectorAll("tr:not(.no-export)");
                if (trList) {
                    for (let i = 0; i < trList.length; i++) {
                        let tr = trList[i];
                        html += "<tr>";
                        //let tdList = tr.querySelectorAll('td:not(.no-export),th:not(.no-export)');
                        let tdList = tr.querySelectorAll("td,th");
                        for (let j = 0; j < tdList.length; j++) {
                            const td = tdList[j];
                            td.querySelectorAll('button,b.th').forEach((r) => {
                                r.remove();
                            });
                            if (!tr.classList.contains("child")) {
                                let isIn = false;
                                for (let k = 0; k < hiddenColumns.length; k++) {
                                    if (j == hiddenColumns[k]) {
                                        isIn = true;
                                        break;
                                    }
                                }
                                if (isIn) {
                                    continue;
                                }
                            }

                            if (td.classList.contains("no-export")) {
                                continue;
                            }

                            let hiddenList = td.querySelectorAll(".no-export");
                            for (let k = 0; k < hiddenList.length; k++) {
                                hiddenList[k].remove();
                            }
                            let tdHtml = callback(td);

                            if (!settings.AllowImg) {
                                tdHtml = Exporter.ExcludeImg(tdHtml);
                            }
                            if (!settings.AllowInput) {
                                tdHtml = Exporter.ExcludeInputs(tdHtml);
                            }
                            if (!settings.AllowLink) {
                                tdHtml = Exporter.ExcludeLinks(tdHtml);
                            }
                            html += tdHtml;
                        }
                        html += "</tr>";
                    }
                }
            }
            return html;
        };
        const getTable = function (t) {
            let tempRows = "";
            if (t) {
                let hiddenColumns = [];
                let thList = t.querySelectorAll("thead > tr > th");
                for (let i = 0; i < thList.length; i++) {
                    if (thList[i].classList.contains("no-export")) {
                        hiddenColumns.push(i);
                    }
                }

                tempRows += getTd(
                    t.querySelector("thead"),
                    function (cell) {
                        //cell.classList - cell.style
                        return "<th>" + cell.innerHTML + "</th>";
                    },
                    []
                );
                tempRows += getTd(
                    t.querySelector("tbody"),
                    function (cell) {
                        //cell.classList - cell.style
                        return "<td>" + cell.innerHTML + "</td>";
                    },
                    hiddenColumns
                );
                tempRows += getTd(
                    t.querySelector("tfoot"),
                    function (cell) {
                        //cell.classList - cell.style
                        return "<th>" + cell.innerHTML + "</th>";
                    },
                    []
                );
            }
            return tempRows;
        };

        if (tableList) {
            let tableRows = [];
            if (Array.isArray(tableList)) {
                // Çoklu Tablo
                for (let i = 0; i < tableList.length; i++) {
                    tableRows.push(getTable(tableList[i]));
                }
            } else {
                tableRows.push(getTable(tableList));
            }

            // Tablo Satıları Hazır
            let fullTemplate = "";
            const utf8Heading =
                '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
            let template = {
                head:
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">' +
                    utf8Heading +
                    "<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets>",
                sheet: {
                    head: "<x:ExcelWorksheet><x:Name>",
                    tail: "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>",
                },
                mid: "</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>",
                table: {
                    head: "<table>",
                    tail: "</table>",
                },
                foot: "</body></html>",
            };

            fullTemplate = template.head;

            if (Array.isArray(tableRows)) {
                for (let i in tableRows) {
                    //fullTemplate += template.sheet.head + '{worksheet' + i + '}' + template.sheet.tail;
                    fullTemplate +=
                        template.sheet.head + settings.SheetName + i + template.sheet.tail;
                }
            }

            fullTemplate += template.mid;

            if (Array.isArray(tableRows)) {
                for (let i in tableRows) {
                    fullTemplate +=
                        template.table.head + "{table" + i + "}" + template.table.tail;
                }
            }

            fullTemplate += template.foot;

            let ctx = {
                worksheet: settings.WorkSheetName,
                sheetName: settings.SheetName,
            };

            if (Array.isArray(tableRows)) {
                for (let i in tableRows) {
                    ctx["table" + i] = tableRows[i];
                }
            }

            let format = function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p]; // worksheet, sheetName, tableX gördüğün yeri ctxteki değerler ile replace yap
                });
            };

            // Export Aşaması

            let isIE = /*@cc_on!@*/ false || !!document.documentMode; // this works with IE10 and IE11 both :)
            //if (typeof msie !== 'undefined' && msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // this works ONLY with IE 11!!!
            if (isIE) {
                if (typeof Blob !== "undefined") {
                    //use blobs if we can
                    fullTemplate = format(fullTemplate, ctx); // with this, works with IE
                    fullTemplate = [fullTemplate];
                    //convert to array
                    let blob1 = new Blob(fullTemplate, { type: "text/html" });
                    window.navigator.msSaveBlob(blob1, settings.FileName);
                    return true;
                } else {
                    //otherwise use the iframe and save
                    //requires a blank iframe on page called txtArea1
                    let frame = document.createElement("iframe");
                    frame.style.width = "640px";
                    frame.style.height = "480px";
                    //d.style.opacity = 0;
                    //d.style.position = "fixed";
                    //d.style.left = "-100%";
                    document.body.appendChild(frame);

                    frame.document.open("text/html", "replace");
                    frame.document.write(format(fullTemplate, ctx));
                    frame.document.close();
                    frame.focus();
                    //let sa = frame.document.execCommand(
                    //  "SaveAs",
                    //  true,
                    //  settings.FileName
                    //);
                    setTimeout(function () {
                        document.body.removeChild(frame);
                    }, 1000);
                    return true;
                }
            } else {
                let blob = new Blob([format(fullTemplate, ctx)], {
                    type: "application/vnd.ms-excel",
                });
                window.URL = window.URL || window.webkitURL;
                let link = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.download = settings.FileName;
                a.href = link;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                return true;
            }
        }
        return false;
    }
    static ToPrint(tableList, title) {
        if (tableList) {
            const div = document.createElement("div");
            if (Array.isArray(tableList)) {
                // Çoklu Tablo
                for (let i = 0; i < tableList.length; i++) {
                    div.innerHTML += tableList[i].outerHTML;
                }
            } else {
                div.innerHTML = tableList.outerHTML;
            }
            const frame = window.open();
            frame.document.write(
                `<html>
            <head>
                <meta charset="utf-8" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                <meta name="viewport" content="width=device-width,initial-scale=1">
                <meta name="robots" content="noindex" />
                <meta name="robots" content="nofollow" />
                <meta name="robots" content="noarchive" />
                <meta name="robots" content="noodp" />
                <title>${C.Str(title)}</title>
                <link rel="stylesheet" href="/assets/css/print.css?v=1.1.100"/>
            </head>
            <body onload="">`
            ); // Print css
            frame.document.write(div.innerHTML);
            frame.document
                .write(`<script type="text/javascript">window.onload = function () {
                document.querySelectorAll('a,button,b.th,.hide-print').forEach((r) => {
                    r.remove();
                });
                const tableList = document.getElementsByTagName('table');
                for (let i = 0; i < tableList.length; i++) {
                    const thList = tableList[i].querySelectorAll('thead > tr > th');
                    for (let j = thList.length - 1; j >= 0; j--) {
                        if (thList[j].classList.contains('no-export')) {
                            const tdList = tableList[i].querySelectorAll('tbody > tr:not(.child) > td:nth-child(' + (j + 1) + ')');
                            for (let k = tdList.length -1; k >= 0; k--) {
                                tdList[k].remove();
                            }
                        }
                    }
                }
                document.querySelectorAll('.no-export').forEach(r => { r.remove(); });
                window.print(); 
                window.close();
            }</script > `);
            //frame.document.write('<script type="text/javascript">window.onload = function () { window.print(); window.close(); }</script>');
            frame.document.write("</body></html>");
            frame.document.close();
            return true;
        }
        return false;
    }
    static ToCopy(tableList) {
        const getTd = function (parent, callback, hiddenColumns) {
            let text = "";
            if (parent) {
                let trList = parent.querySelectorAll("tr:not(.no-export)");
                if (trList) {
                    for (let i = 0; i < trList.length; i++) {
                        let tr = trList[i];
                        //text += '';
                        //let tdList = tr.querySelectorAll('td:not(.no-export),th:not(.no-export)');
                        let tdList = tr.querySelectorAll("td,th");
                        for (let j = 0; j < tdList.length; j++) {
                            const td = tdList[j];
                            td.querySelectorAll('a,button,b.th').forEach((r) => {
                                r.remove();
                            });
                            if (!tr.classList.contains("child")) {
                                let isIn = false;
                                for (let k = 0; k < hiddenColumns.length; k++) {
                                    if (j == hiddenColumns[k]) {
                                        isIn = true;
                                        break;
                                    }
                                }
                                if (isIn) {
                                    continue;
                                }
                            }

                            if (td.classList.contains("no-export")) {
                                continue;
                            }
                            let hiddenList = td.querySelectorAll(".no-export");

                            for (let k = 0; k < hiddenList.length; k++) {
                                hiddenList[k].remove();
                            }
                            let tdText = callback(td);
                            text += tdText + (j + 1 < tdList.length ? "\t" : ""); // boşluk
                        }
                        text += "\r\n";
                    }
                }
            }
            return text;
        };
        const getTable = function (t) {
            let tempRows = "";
            if (t) {
                let hiddenColumns = [];
                let thList = t.querySelectorAll("thead > tr > th");
                for (let i = 0; i < thList.length; i++) {
                    if (thList[i].classList.contains("no-export")) {
                        hiddenColumns.push(i);
                    }
                }

                tempRows += getTd(
                    t.querySelector("thead"),
                    function (cell) {
                        return cell.innerText;
                    },
                    []
                );
                tempRows += getTd(
                    t.querySelector("tbody"),
                    function (cell) {
                        return cell.innerText;
                    },
                    hiddenColumns
                );
                tempRows += getTd(
                    t.querySelector("tfoot"),
                    function (cell) {
                        return cell.innerText;
                    },
                    []
                );
            }
            return tempRows;
        };

        if (tableList) {
            let tableRows = [];
            if (Array.isArray(tableList)) {
                // Çoklu Tablo
                for (let i = 0; i < tableList.length; i++) {
                    tableRows.push(getTable(tableList[i]));
                }
            } else {
                // Tek Tablo
                tableRows.push(getTable(tableList));
            }

            let fullTemplate = "";

            if (Array.isArray(tableRows)) {
                for (let i = 0; i < tableRows.length; i++) {
                    if (i > 0) {
                        fullTemplate +=
                            "\n----------------------------------------------\n";
                    }
                    fullTemplate += tableRows[i];
                }
            }

            // Kopyala
            Web.ClipboardText(fullTemplate, false);
            return true;
        }
        return false;
    }
}

export class Animation {
    constructor() { }
    static Counter(sender, start = 0, end, duration = 1000, isMoney = false) {
        let startTimestamp = null;
        let step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            if (isMoney) {
                sender.innerText = C.Money(progress * (end - start) + start);
            } else {
                sender.innerText = C.InsertDot(
                    Math.floor(progress * (end - start) + start)
                );
            }
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }
}

//export const Tooltip = {
//    mounted(el, binding) {
//        let callback = function (isCreated) {
//            if (isCreated) {
//                let div = document.getElementById(el.tooltipId);
//                if (div) { div.remove(); }
//                el.tooltipId = null;
//            }
//            else {
//                el.tooltipId = Rnd.Id(50);
//                let div = document.createElement('div');
//                div.setAttribute('id', el.tooltipId);
//                div.classList.add('long-text');
//                div.classList.add('tooltip-text');
//                if (C.Str(el.getAttribute('text')) != '') { div.innerText = el.getAttribute('text'); }
//                else { div.innerHTML = el.getAttribute('html'); }
//                el.parentNode.insertBefore(div, el.nextSibling);
//            }
//        }

//        let target = [];
//        switch (C.Str(el.getAttribute('target'))) {
//            case 'click':
//                target = ['mousedown', 'mouseup'];
//                break;
//            case 'hover':
//            default:
//                target = ['mouseover', 'mouseout'];
//                break;
//        }
//        el.addEventListener(target[0], function () { callback(false); });
//        el.addEventListener(target[1], function () { callback(true); });
//    },
//};